import { render } from "./ContactBooksSchemaEditorItemContent.vue?vue&type=template&id=08570f87&ts=true"
import script from "./ContactBooksSchemaEditorItemContent.vue?vue&type=script&lang=ts"
export * from "./ContactBooksSchemaEditorItemContent.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/bn/cmp7482d0pnd0bj6pmy1gdj40000gn/T/deploy/contacts-ui/dec300672a634ec0751305bce5d90b84f1aba731/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.37_vue@3.4.18_webpack@5.87.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__